import Create from './create/CreateCost';
import Edit from './edit/EditCost';
import Individual from './individual/Cost';

export default { Individual, Edit, Create };
